<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartText :text="customer.name" :subtext="subtext" :header="`Asignado ${dateDiff}`" @select="option" />
		<LayoutTableCommonPartInfo :info="extras" />
		<LayoutTableCommonPartRaw class="text-end" width="20%">
			<CustomerCommonStatusInfo :customer_user="customer.pivot" />
		</LayoutTableCommonPartRaw>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed, getCurrentInstance } from 'vue';
	import moment from 'moment';

	export default {
		props: {
			customer: Object,
			selectable: Boolean
		},
		setup(props) {
			const instance = getCurrentInstance();
			const dateDiff = computed(() => moment(props.customer.pivot.created_at).fromNow());
			const option = () => {
				if(props.selectable) instance.proxy.$customerOption(props.customer);
			}

			const subtext = computed(() => {
				let data = [];

				data.push((!props.customer.group) ? 'Sin grupo asignado' : props.customer.group.name);

				return data.join(' · ');
			});

			const extras = computed(() => {
				let data = [];

				if('last_buy' in props.customer.extras) {
					data.push(`<b>Última compra:</b> ${moment(props.customer.extras.last_buy).fromNow()}`);
				}

				if('total_buy' in props.customer.extras) {
					let numberFormat = new Intl.NumberFormat('es-ES');
					data.push(`<b>Compra total:</b> $ ${numberFormat.format(props.customer.extras.total_buy)}`);
				}

				if('birthdate' in props.customer.extras) {
					data.push(`<b>Cumpleaños:</b> ${moment(props.customer.extras.birthdate).format('dddd D [de] MMMM')}`);
				}

				if('group' in props.customer && props.customer.group) {
					data.push(`<b>Grupo:</b> ${props.customer.group.name}`);
				}

				if(data.length == 0) {
					data.push('Sin información adicional');
				}

				return data.join('<br />');
			});

			return { dateDiff, option, subtext, extras };
		}
	}
</script>